import React from "react";
import Image from "gatsby-image";
import {ArticlePhotos} from "./ArticlePhotos";
import Opengraph from 'assets/images/blog/article_9/shoper_doskonaly_sposob_sprzedazy_w_internecie_og.png';
import {useAuthorsData} from "../../Authors/useAuthorsData";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();

  return {
    date: "08.06.2021r",
    category: "shoper, marketing-internetowy, e-commerce",
    title: "Shoper - doskonały sposób sprzedaży w internecie",
    description:
      "Trwa pandemia. Galerie handlowe i sklepy stacjonarne są zamykane. Każda marka działająca w handlu musi walczyć o przetrwanie i pozostanie na rynku. Brzmi jak apokalipsa? Witamy w latach 20. XXI wieku. Ale dość pisania czarnych scenariuszy. Czas na działanie. I tak jak zrobiło to wiele marek - wprowadzenie lub rozwinięcie sprzedaży online.",
    seo:
      "Trwa pandemia. Galerie handlowe i sklepy stacjonarne są zamykane. Każda marka działająca w handlu musi walczyć o przetrwanie i pozostanie na rynku. Brzmi jak apokalipsa? Witamy w latach 20. XXI wieku. Ale dość pisania czarnych scenariuszy.",
    slug: "/blog/shoper_doskonaly_sposob_sprzedazy_w_internecie",
    ogImage: Opengraph,
    authors: [
    authors.GrzegorzSowa
    ],
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "Boom na sklepy online",
        text: (
          <>
            W Polsce zakupy przez internet robi ponad 70% użytkowników całej sieci. W&nbsp;samym kwietniu 2020 r. zostało założonych aż o 137% więcej nowych sklepów niż w kwietniu poprzedniego roku.* Jest to bardzo duży wzrost. Społeczeństwo jest coraz bardziej wygodne, a&nbsp;sytuacja związana z pandemią dodatkowo potęguje zainteresowanie branżą e-commerce. Dlatego nic dziwnego, że w ostatnim czasie sklepy internetowe wyrastają jak grzyby po deszczu i&nbsp;zyskują coraz więcej klientów!
          </>
        ),
      },
      second: {
        title: "Poznaj platformę Shoper",
        text: (
          <>
            Na rynku dostępnych jest wiele opcji, które umożliwiają założenie sklepu internetowego - od otwartych oprogramowań (tzw. OpenSource), po platformy w&nbsp;modelu Saas (Software as a Service). Model abonamentowy jest zdecydowanie częściej używany, co potwierdza fakt, że <b>Shoper jest najpopularniejszą platformą sklepową w&nbsp;Polsce</b>.
          </>
        ),
      },
      third: {
        title: "",
        text: (
          <>
            Shoper to gotowe oprogramowanie. Pozwala na zarządzenie sklepem internetowym, dostosowywanie jego funkcjonalności i&nbsp;poszerzenie bazy produktów. Obsługuje cały proces zakupowy - od przyjęcia zamówienia, przez jego wysyłkę, aż do rozliczenia. Umożliwia także dostosowanie wyglądu strony sklepu zgodnie z&nbsp;własnymi upodobaniami.
          </>
        ),
      },
      fourth: {
        title: "Jakie zalety posiada Shoper?",
        text: (
          <>
            Chcesz jak najszybciej rozpocząć sprzedaż swoich produktów w internecie? Żaden problem! Dzięki temu, że platforma Shoper to gotowe oprogramowanie, wystarczy tylko konfiguracja. Co więcej, jest na tyle intuicyjne, że wdrożenie go nie zajmuje dużo czasu. Rozwiązanie SaaS zapewnia wszytko, czego potrzebuje sprawnie działający sklep online. Shoper gwarantuje zaplecze hostingowe, zabezpieczenie oprogramowania, automatyczne aktualizacje czy gotowe integracje z dodatkowym systemem. Możliwe jest połączenie e-sklepu z Allegro, Facebookiem, Google, systemem płatności, ofertą firm kurierskich oraz wieloma innymi usługami dla e-commerce.
          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>
            System posiada czytelny oraz <b>intuicyjny panel administratorski</b>. Umożliwia prowadzenia firmowego bloga, co dodatkowo wspomaga pozycjonowanie strony. Pozwala na sprzedaż niezliczonej ilości produktów. Niewątpliwą zaletą Shopera jest także niski początkowy koszt uruchomienia sklepu oraz <b>korzystna cena abonamentu</b>. Oprogramowanie to opiera się na najlepszych w branży, sprawdzonych rozwiązaniach. Dzięki temu, że jest najczęściej wybieraną platformą, stale wprowadzane są nowe funkcje. Jeszcze bardziej ułatwiają one prowadzenie działalności sprzedażowej w&nbsp;sieci i oferowanie klientom wielu produktów.
            Shoper nie jest rozwiązaniem kierowanym tylko do dużych firm. Nieważne, ile i&nbsp;jakie produkty chcesz sprzedawać. Ważne, że chcesz dostosować swoją ofertę do potrzeb oraz oczekiwań klientów i&nbsp;rynku.
          </>
        ),
      },
      sixth: {
        title: "Zainteresownany?",
        text:
          <>
            Jeśli chcesz wprowadzić do swojej oferty sklep internetowy, możesz zlecić to nam. Jesteśmy autoryzowanym resellerem Shopera. Przygotujemy w&nbsp;pełni profesjonalny i&nbsp;funkcjonalny sklep, który przeniesie sprzedaż Twoich produktów do innego wymiaru. Zajmiemy się także wdrażaniem zmian i&nbsp;wszystkimi pracami konfiguracyjnymi. Z&nbsp;doświadczenia wiemy, że jest to oprogramowanie online, które się sprawdza. Dzięki prostemu panelowi administracyjnemu pozwala na samodzielne prowadzenie sprzedaży w&nbsp;sieci, co dodatkowo zachęca klientów. Z InteractiveVision możesz mieć e-sklep już w 2 tygodnie! Platforma Shoper to rozwój Twojego biznesu. <br/><br/> *Dane na podstawie raportu &bdquo;E-commerce w Polsce 2020. Gemus dla eCommerce Polska&rdquo;.
          </>
      },
    },
    images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
    },
  };
};
